/* eslint-disable no-unused-vars */
import { Palette } from 'config';
import styled from 'styled-components';

export const LoaderBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 60px;
`;

export const SubHeading = styled.p`
  max-width: 100%;
  display: block;
  flex-shrink: 0;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${Palette.PrimaryGray._700};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const PaymentIconWrap = styled.div`
  margin-bottom: 8px;
  display: flex;
  gap: 24px;
  align-items: center;
`;

export const PaymentsType = styled.div`
  display: flex;
  gap: 8px;
`;

export const Label = styled.label`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${Palette.PrimaryGray._700};
  cursor: pointer;

  ${(props) =>
    !props.isActive &&
    `
    cursor: auto;
    opacity: 0.4;
  `}
`;

export const PaymentMethodsWrap = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 23px;
`;

export const PaymentMethod = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 32px;
  align-items: flex-start;
  max-width: 100%;
  overflow: hidden;
`;

export const Text = styled.p`
  font-size: 14px;
  line-height: 20px;
  color: ${Palette.PrimaryGray._700};
`;

export const WireText = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
  font-size: 14px;
  line-height: 20px;
  color: ${Palette.PrimaryGray._700};
  margin-bottom: 4px;
  white-space: nowrap;

  & span {
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const WireTitle = styled(Text)`
  font-weight: 500;
`;

export const SmallText = styled.p`
  font-size: 12px;
  line-height: 16px;
  color: ${Palette.PrimaryGray._700};
  margin-bottom: 4px;
`;

export const ExternalLink = styled.a`
  color: ${Palette.Primary._500};
  text-decoration: underline;
`;

export const StyledForm = styled.form`
  padding: unset;
  padding-right: 16px;
  width: 100%;
  height: auto;
  box-shadow: unset;
  margin-top: 16px;
  margin-right: 20px;
`;

export const ButtonsWrap = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;
`;

export const HintText = styled(SmallText)`
  position: absolute;
  top: 20px;
  max-width: calc(100% - 240px);
`;
